import React from "react";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

const Container: React.FC<ContainerProps> = ({ children, className = "" }) => {
  return (
    <div
      className={`
        mb-10
        w-full
        md:pl-36
        md:pr-24
        lg:pl-52
        lg:pr-32
        xl:pl-72
        xl:pr-64


        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default Container;
